import { collectDressing, primeDressing } from '../utils/dressing-loader';

/**
 * Exposes `$dressing(tag)` to every Alpine component on the page, and
 * `window.primeDressing()` to the form triggers that start the download.
 *
 * Registering the magic is free — it touches no network. The agent download is
 * deliberately not started here: this module rides in app.js, which every page
 * loads, and priming from it would hit the endpoint on pages that hold no form.
 * Callers prime instead, on the same triggers that inject reCAPTCHA's script.
 *
 * The magic is a magic rather than an Alpine.data() component because the login,
 * review, and join forms all carry substantial inline x-data that would otherwise
 * have to be restructured to compose with it.
 *
 * Config comes from the `GS` namespace published by DressingConfigComposer, so the
 * key is not duplicated across the three Blade files. The layout writes that object
 * from an inline script in the head, ahead of this deferred module, so it is always
 * populated by the time anything below runs.
 */
function readConfig() {
    return {
        apiKey: window.GS?.dressing?.apiKey ?? '',
        endpoint: window.GS?.dressing?.endpoint ?? '',
    };
}

/**
 * A global rather than an Alpine magic because every caller is a plain inline
 * script with no Alpine component scope to reach a magic through — the layout's
 * `open-modal` listener, the join modal's, and the login and review pages' head
 * pushes. `grecaptcha` is a global for the same reason.
 *
 * Assigned at module scope, not on `alpine:init`, so a trigger that fires before
 * Alpine boots still starts the download.
 */
window.primeDressing = () => primeDressing(readConfig());

// Wait until Alpine is initialized before registering the magic
document.addEventListener('alpine:init', () => {
    Alpine.magic('dressing', () => (tag) => collectDressing(readConfig(), { tag }));
});
